import React from 'react';
import { Content } from './components';
import { CpSpacesListView } from './space-list-view';
import { CpSpacesSidePane } from './space-side-pane';
import { CpSpaceProps } from './types';

export const CpSpaceForMobile: React.FC<CpSpaceProps> = ({
  search,
  currentSpace,
  onSpaceClick,
  data,
  currentSpaceTabs,
  onSpaceTabClick,
}) => {
  if (!currentSpace) {
    return (
      <CpSpacesSidePane
        search={search}
        currentSpace={currentSpace}
        onSpaceClick={onSpaceClick}
        data={data}
      />
    );
  }

  return (
    <Content>
      {/* <ContentTitleWrapper>
        <BackIconWrapper
          onClick={() => {
            onSpaceClick(undefined);
          }}
        >
          <ChevronLeft16 />
        </BackIconWrapper>
        <ContentTitle>{currentSpace?.spaceName}</ContentTitle>
      </ContentTitleWrapper> */}
      <CpSpacesListView
        spaceTabs={currentSpaceTabs}
        onSpaceTabClick={onSpaceTabClick}
      />
    </Content>
  );
};
